import * as Yup from "yup";
import { forceInt } from "Utils";
import { transform as contentTransformer } from "./Content";
import { transform as workflowTransformer } from "./Workflow";
import { transform as userTransformer } from "./User";
import { fromSqlDateTime } from "../helpers/Date";

export const VersionValidationSchema = Yup.object().shape({});

export const VersionObjectSchema = {
    id: null,
    uuid: null,
    srn: null,
    slug: "",
    content: null,
    content_raw: null,
    abstract: null,
    abstract_raw: null,
    title: "",
    title_url: "",
    type: null,
    created_at: null,
    modified_at: null,
    published_at: null,
    weight: 0,
    status: null,
    version: null,
    content_id: null,
    parent_content: {},
    workflow: {},
    user: {},
};

/**
 * Transform API object to a Content object
 * @param {object} requestData JSON object from the API
 * @returns Object
 */
export function transform(requestData) {
    if (requestData.data) {
        return requestData.data.map((item) => transform(item));
    }

    let version = Object.assign({}, VersionObjectSchema, {
        id: forceInt(requestData.id),
        uuid: requestData.uuid,
        srn: requestData.srn,
        slug: requestData.slug,
        title_url: requestData.title_url,
        content: requestData.content,
        content_raw: requestData.content_raw,
        abstract: requestData.abstract,
        abstract_raw: requestData.abstract_raw,
        title: requestData.title,
        type: requestData.type,
        created_at: requestData.created_at,
        modified_at: requestData.modified_at,
        published_at: requestData.published_at,
        weight: requestData.weight,
        status: requestData.status,
        version: forceInt(requestData.version),
        content_id: forceInt(requestData.version),
        last_changed: fromSqlDateTime(requestData.modified_at).toMillis(),
    });

    if (requestData.workflow) {
        let wf = workflowTransformer(requestData.workflow);
        version = Object.assign({}, version, { workflow: wf });
    }

    if (requestData.parent_content) {
        let pc = contentTransformer(requestData.parent_content);
        version = Object.assign({}, version, { parent_content: pc });
    }

    if (requestData.user) {
        let user = userTransformer(requestData.user);
        version = Object.assign({}, version, { user: user });
    }

    return version;
}

/**
 * Serialize the content object to a string
 * @param {object} item
 * @returns string
 */
export function serialize(item) {
    return JSON.stringify(item);
}

/**
 * Deserialize json string
 * @param {string} item
 * @returns object
 */
export function deserialize(item) {
    return JSON.parse(item);
}
